/* eslint-disable prettier/prettier */
import { http_mongo } from "../../configs/http-mongo";
import { http_admin } from "../../configs/http-admin";

const state = {
  statusBack: false,
  objectNope: {},
  objectLike: {},

  resultNope: {},

  listImageThumbnail: [],

  listTopic: [],

  listTopicVerified: {},
  listTopicOther: [],
  listCardTopic: {},
  listCardTopicOld: [],
  indexValue: 0,
  tabActive: 0,
  listLikeYous: [],
  listYouLikes: [],

  listLikeFilter: {
    currentPage: 0,
    skip: 0,
    limit: 0,
    count: 0,
    total: 0,
    list_data: [],
  },

  listInterestFilters: [],

  objectFilterLike: {
    distance: 50,
    ageMin: 18,
    ageMax: 25,
    numberPhoto: 3,
    interests: [],
    statusVerified: false,
    statusBio: false,
    lat: 0,
    long: 0,
  },
};

const getters = {};

const mutations = {
  setTabActive(state, data) {
    state.tabActive = data;
  },
  setPostNopeUser(state, data) {
    state.resultNope = data;
  },
  setPostBackUser(state, data) {
    state.statusBack = data;
  },
  setSaveObjectNope(state, data) {
    state.objectNope = data;
  },
  setSaveObjectBack(state, data) {
    this.state.profileModule.cardFeed = state.objectNope;
  },
  setPostLikeUser(state, data) {
    state.objectLike = data;
  },

  setPostImageThumbnail(state, data) {
    state.listImageThumbnail = data;
  },

  setTopicExplore(state, data) {
    if (state.listTopicOther.length === 0) {
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        if (element.typeExplore === 0) {
          state.listTopicVerified = element;
        } else {
          state.listTopicOther.push(element);
        }
      }
    }
  },

  setTopicCard(state, data) {
    state.listCardTopicOld = data;
    if (data[0] === undefined) {
      state.listCardTopic = {};
    } else {
      debugger;
      state.listCardTopic = data[0];
    }
  },

  setObjectCardTopic(state, val) {
    debugger;
    if (val === true) {
      state.indexValue = state.indexValue + 1;

      state.listCardTopic = state.listCardTopicOld[state.indexValue]
        ? state.listCardTopicOld[state.indexValue]
        : [];
    } else {
      state.indexValue = state.indexValue - 1;
      state.listCardTopic = state.listCardTopicOld[state.indexValue]
        ? state.listCardTopicOld[state.indexValue]
        : [];
    }
  },

  setListOtherUsersLikeYou(state, data) {
    state.listLikeYous = data.list_data;
  },

  setListYouLikeOtherUsers(state, data) {
    state.listYouLikes = data.list_data;
  },

  setListCardYouLike(state, data) {
    debugger;
    const index = state.listYouLikes.findIndex((x) => x._id === data._id);
    if (index !== -1) {
      state.listYouLikes.splice(index, 1);
    }
    debugger;
  },

  setListCardLikeYou(state, data) {
    debugger;
    const index = state.listLikeYous.findIndex((x) => x._id === data._id);
    if (index !== -1) {
      state.listLikeYous.splice(index, 1);
    }
    debugger;
  },

  setInterestChecked(state, data) {
    debugger;
    state.listInterestFilters = data.objectChecked;
    state.objectFilterLike.interests = data.interestCode;
  },

  setDistanceFilter(state, data) {
    state.objectFilterLike.distance = data;
  },

  setAgeRangeFilter(state, data) {
    state.objectFilterLike.ageMin = data.showAgeMin;
    state.objectFilterLike.ageMax = data.showAgeMax;
  },

  setVerifiedPhoto(state, data) {
    state.objectFilterLike.statusVerified = data;
  },

  setShowBio(state, data) {
    state.objectFilterLike.statusBio = data;
  },

  setListFilterLikes(state, data) {
    state.listYouLikes = data.list_data;
  },

  setNumberPhoto(state, data) {
    state.objectFilterLike.numberPhoto = data;
  },

  setReasonReport(state, data) {
    state.reportUser = data;
  },
};

const actions = {
  /**
   * Chức năng nope
   * @param {*} param0
   * @param {*} data
   * @returns
   */
  async postNopeUser({ commit }, data) {
    await http_mongo
      .post(`/api/v1/nope`, data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tokenIdV2")}`,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          commit("setPostNopeUser", response.data.data);
        }
      })
      .catch((error) => {});
  },

  async postLikeUser({ commit }, data) {
    return new Promise((resolve, reject) => {
      http_mongo
        .post(`/api/v1/like`, data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tokenIdV2")}`,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            commit("setPostLikeUser", response.data.data);
            resolve(response.data.data);
          } else {
            reject("Error: API returned non-200 status");
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * Chức năng back
   * @param {*} param0
   * @param {*} data
   * @returns
   */
  async postBackUser({ commit }, data) {
    return new Promise((resolve, reject) => {
      http_mongo
        .post(`/api/v1/back`, data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tokenIdV2")}`,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            commit("setPostBackUser", response.status);
            resolve(response.data.data);
          } else {
            reject("Error: API returned non-200 status");
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * Chức năng supper like
   * @param {*} param0
   * @param {*} data
   * @returns
   */
  async postSupperLikeUser({ commit }, data) {
    return new Promise((resolve, reject) => {
      http_mongo
        .post(`/api/v1/superLike`, data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tokenIdV2")}`,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            commit("setPostSupperLikeUser", response.data.data);
            resolve(response.data.data);
          } else {
            reject("Error: API returned non-200 status");
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * Lấy danh sách topic
   * @param {*} param0
   * @param {*} data
   */
  async getTopicExplore({ commit }, data) {
    return new Promise((resolve, reject) => {
      http_mongo
        .get(`api/v1/topics`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tokenIdV2")}`,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            commit("setTopicExplore", response.data.data);
            resolve(response.data.data);
          } else {
            reject("Error: API returned non-200 status");
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * Lấy danh sách card topic
   * @param {*} param0
   * @param {*} data
   * @returns
   */
  async getTopicCard({ commit }, data) {
    return new Promise((resolve, reject) => {
      http_mongo
        .get(
          `api/v1/cards/group/${data.idTopic}?pageSize=${data.pageSize}&currentPage=${data.currentPage}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("tokenIdV2")}`,
            },
          }
        )
        .then((response) => {
          if (response.status === 200) {
            commit("setTopicCard", response.data.data);
            resolve(response.data.data);
          } else {
            reject("Error: API returned non-200 status");
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * Lấy danh sách những người like bạn
   * @param {*} param0
   * @param {*} data
   * @returns
   */
  async getListOtherUsersLikeYou({ commit }, data) {
    return new Promise((resolve, reject) => {
      http_mongo
        .get(
          `api/v1/list-action-you?pageSize=${data.pageSize}&currentPage=${data.currentPage}&action=${data.action}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("tokenIdV2")}`,
            },
          }
        )
        .then((response) => {
          if (response.status === 200) {
            commit("setListOtherUsersLikeYou", response.data.data);
            resolve(response.data.data);
          } else {
            reject("Error: API returned non-200 status");
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  async getListYouLikeOtherUsers({ commit }, data) {
    return new Promise((resolve, reject) => {
      http_mongo
        .get(
          `api/v1/list-you-action?pageSize=${data.pageSize}&currentPage=${data.currentPage}&action=${data.action}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("tokenIdV2")}`,
            },
          }
        )
        .then((response) => {
          if (response.status === 200) {
            commit("setListYouLikeOtherUsers", response.data.data);
            resolve(response.data.data);
          } else {
            reject("Error: API returned non-200 status");
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * Filter like
   * @param {*} param0
   * @param {*} data
   * @returns
   */
  async getListFilterLikes({ commit }, data) {
    return new Promise((resolve, reject) => {
      http_mongo
        .post(
          `/api/v1/list-fillter-like?pageSize=${data.pageSize}&currentPage=${data.currentPage}&action=${data.action}`,
          data.objectLike,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("tokenIdV2")}`,
            },
          }
        )
        .then((response) => {
          if (response.status === 200) {
            debugger;
            commit("setListFilterLikes", response.data.data);
            resolve(response.data.data);
          } else {
            reject("Error: API returned non-200 status");
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  async postReasonReport({ commit }, data) {
    return new Promise((resolve, reject) => {
      http_mongo
        .post(`/api/v1/report`, data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tokenIdV2")}`,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            debugger;
            commit("setReasonReport", response.data.data);
            resolve(response.data.data);
          } else {
            reject("Error: API returned non-200 status");
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  async postImageThumbnail({ commit }, data) {
    debugger;
    return new Promise((resolve, reject) => {
      http_admin
        .post(
          `api/upload-thumbnail?pageSize=${data.pageSize}&currentPage=${data.currentPage}`,
          { listImage: data.listImage },
          {
            headers: {
              Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiIwMUhNNUtON05ZM1JSWDVDRDI1Ujc5NkFZVCIsImVtYWlsIjoiYWRtaW4iLCJuYW1lIjoiQWRtaW5pc3RyYXRvciIsInJvbGUiOiJhZG1pbiIsImV4cCI6MTcxNDU4NDYyNiwiaWF0IjoxNzEzOTc5ODI2fQ.2yQKgid-zPvtrvquDD2P-7wO2yR5DD8Tbdi-i8kxYdc`,
            },
          }
        )
        .then((response) => {
          debugger;
          if (response.status === 200) {
            commit("setPostImageThumbnail", response.data.data);
            resolve(response.data.data);
          } else {
            reject("Error: API returned non-200 status");
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  async getAccountUser({ commit }, data) {
    debugger;
    return new Promise((resolve, reject) => {
      http_admin
        .get(`api/users`, {
          headers: {
            Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiIwMUhNNUtON05ZM1JSWDVDRDI1Ujc5NkFZVCIsImVtYWlsIjoiYWRtaW4iLCJuYW1lIjoiQWRtaW5pc3RyYXRvciIsInJvbGUiOiJhZG1pbiIsImV4cCI6MTcxMzgzNjEyMCwiaWF0IjoxNzEzMjMxMzIwfQ.AFyN70YnCHyr_jzIW-SH_TqADQOuO3jfZLci3IalKoo`,
          },
        })
        .then((response) => {
          debugger;
          if (response.status === 200) {
            resolve(response.data.data);
          } else {
            reject("Error: API returned non-200 status");
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
